/*
 *
 * SubrouteHeader
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 26-Nov-2024
 */

import SubrouteHeader from './SubrouteHeader'

export default SubrouteHeader
